<script>
const generateTempKey = () => `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

const emptyLinkRel = () => ({
  id: null,
  tempKey: generateTempKey(),
  url: '',
  nofollow: false,
  sponsored: false
})

export default {
  name: 'LinkRelsList',
  components: {
    Action: () => import('@/components/general/Action'),
    Icon: () => import('@/components/general/Icon'),
    InputField: () => import('@/components/general/InputField'),
    Checkbox: () => import('@/components/general/Checkbox')
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },

    validation: {
      type: Object,
      default: () => ({})
    },

    maxUrl: {
      type: Number,
      default: 500
    }
  },

  methods: {
    fieldValidation (index) {
      const each = this.validation && this.validation.$each

      return each ? each[index].url : {}
    },

    add () {
      this.$emit('input', [
        ...this.items,
        emptyLinkRel()
      ])
    },

    remove (index) {
      const next = this.items.slice()

      next.splice(index, 1)
      this.$emit('input', next)
    },

    patchItem (index, patch) {
      const next = this.items.map((item, i) => (i === index
        ? {
          ...item,
          ...patch
        }
        : item))

      this.$emit('input', next)
    }
  }
}
</script>

<template>
  <div>
    <div
      v-for="(item, index) in items"
      :key="item.id || item.tempKey || index"
      class="article-linkrel-item"
    >
      <div class="article-linkrel-item-header">
        <span class="article-linkrel-item-number">
          {{ $t('articles.form:linkrel.item', { number: index + 1 }) }}
        </span>
        <button
          type="button"
          class="article-linkrel-item-remove"
          :aria-label="$t('articles.form:linkrel.remove')"
          @click="remove(index)"
        >
          <Icon name="delete" />
        </button>
      </div>

      <InputField
        :label="$t('articles.form:linkrel.url')"
        :value="item.url"
        :validation="fieldValidation(index)"
        :counter="maxUrl"
        @input="(value) => patchItem(index, { url: value })"
      />

      <div class="article-linkrel-toggles">
        <Checkbox
          :value="item.nofollow"
          :items="[{ value: 'nofollow', label: $t('articles.form:linkrel.nofollow') }]"
          switch-type
          @input="(value) => patchItem(index, { nofollow: Boolean(value) })"
        />
        <Checkbox
          :value="item.sponsored"
          :items="[{ value: 'sponsored', label: $t('articles.form:linkrel.sponsored') }]"
          switch-type
          @input="(value) => patchItem(index, { sponsored: Boolean(value) })"
        />
      </div>
    </div>

    <Action
      type="button"
      flat
      icon="add"
      :text="$t('articles.form:linkrel.add')"
      @click="add"
    />
  </div>
</template>
